import { FieldErrors } from 'react-hook-form/dist/types';
import { DyHeader } from 'src/constants';
import { DyProductSource, IGcfComponentConfig } from 'src/interfaces';

import { DyHeaderOptions } from './HeaderWidget.interface';

export const getHeaderKey = (
  componentConfig: IGcfComponentConfig,
  headerType: DyHeaderOptions,
) => {
  const source = componentConfig?.productsSource;

  return source === DyProductSource.DYR || source === DyProductSource.DYS
    ? componentConfig?.[headerType]?.header
    : componentConfig?.header;
};

export const getHeaderKeyString = (
  componentConfig: IGcfComponentConfig,
  headerType: DyHeaderOptions,
  key?: string,
): string => {
  const source = componentConfig?.productsSource;
  const baseKey =
    source === DyProductSource.DYR || source === DyProductSource.DYS
      ? `${headerType}.header`
      : 'header';

  return key ? `${baseKey}.${key}` : baseKey;
};

export const getErrorKey = (
  componentConfig: IGcfComponentConfig,
  headerType: DyHeaderOptions,
  errors: FieldErrors<IGcfComponentConfig>,
) => {
  const source = componentConfig?.productsSource;

  return source === DyProductSource.DYR || source === DyProductSource.DYS
    ? errors?.[headerType]?.header
    : errors?.header;
};
export const getHeader = (
  componentConfig: IGcfComponentConfig,
  headerType: DyHeaderOptions,
): { text: string } | undefined => {
  if (!componentConfig) return undefined;

  const { productsSource, dyHeaders, knownCustomer, unknownCustomer, header } =
    componentConfig;

  const isKnown = headerType === DyHeaderOptions.KNOWN;

  if (
    productsSource === DyProductSource.DYR ||
    productsSource === DyProductSource.DYS
  ) {
    const dyValue =
      dyHeaders?.[productsSource]?.[isKnown ? 'known' : 'unknown']?.trim();
    if (dyValue) {
      return { text: dyValue };
    }

    // ✅ Use constants from DyHeader
    const defaultText =
      productsSource === DyProductSource.DYR
        ? isKnown
          ? DyHeader.recommendation.knownCustomer
          : DyHeader.recommendation.unknownCustomer
        : isKnown
        ? DyHeader.suggestion.knownCustomer
        : DyHeader.suggestion.unknownCustomer;

    return { text: defaultText };
  }

  const fallbackText = isKnown
    ? knownCustomer?.header?.text
    : unknownCustomer?.header?.text;
  const finalText = fallbackText?.trim() || header?.text?.trim();

  return finalText ? { text: finalText } : undefined;
};

export const convertSpacesToHTMLFormat = (html?: string): string => {
  const htmlRegex = /(?<=>|^)([^<]+)(?=<|$)/g;

  return html
    ? html.replace(htmlRegex, (match) => match.replace(/ /g, '\u00A0'))
    : '';
};
